import React, { PropsWithChildren } from 'react';
import { Fieldset, FieldsetModifier } from '../Fieldset/Fieldset';
import { Row, RowModifier } from '../../grid/Row/Row';
import bem from '../../../../lib/bemUtils/bem';

type RadioGroup = PropsWithChildren<{
  legend: string;
  orientation?: 'vertical' | 'horizontal';
  fieldsetModifier?: FieldsetModifier;
  rowModifier?: RowModifier;
  required?: boolean;
  helpText?: string;
}>;

export function RadioGroup({
  legend,
  orientation = 'horizontal',
  fieldsetModifier,
  rowModifier,
  children,
  required = false,
  helpText,
}: RadioGroup) {
  return (
    <Fieldset modifier={fieldsetModifier} legend={legend} required={required} helpText={helpText}>
      <Row modifier={rowModifier}>
        <div className={bem('radio-group', orientation)}>{children}</div>
      </Row>
    </Fieldset>
  );
}
